import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import PlayApp from "./play-app"
import { PlayContextProvider } from "play/context/play-context"

const rootElement = document.getElementById("root")
if (!rootElement) {
  throw "Cannot find root element for react app"
}
const root = createRoot(rootElement)
root.render(
  // <StrictMode>
  <PlayContextProvider>
    <PlayApp />
  </PlayContextProvider>
  // </StrictMode>
)
